<template>
  <div class="blue-container">
      <div class="container">
          <h1>Browse Jobs</h1>
      </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.blue-container {
  width: 100%;
  height: 400px;
  background: #17A2B8;
  color: #fff;
  padding: 4em 0 2em;
  border-top-left-radius: 40px;
  transform: skewY(-2deg);
}

.blue-container:before {
  content: "";
  width: 40px;
  height: 40px;
  background-color: #17A2B8;
  position: absolute;
  top: -39px;
  right: 0;
  z-index: -2;
}

.blue-container:after {
  content: "";
  width: 80px;
  height: 80px;
  background-color: #fff;
  position: absolute;
  top: -80px;
  right: 0;
  border-radius: 50%;
  z-index: -1;
}

.blue-container h1{
    transform: skewY(2deg);
}

.container{
    text-align: center;
    padding: .8em 1.2em;
}
</style>
